import logo from './content/images/logo.png';
import './App.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} />
        <p>
          Centro de eventos
        </p>
        <a
          className="App-link"
          href="https://wa.me/573014807777"
          target="_blank"
          rel="noopener noreferrer"
        >
          Escribenos
        </a>
      </header>
    </div>
  );
}

export default App;
